import EmailTemplete from "./EmailTemplete";

export { EmailTemplete };


// WEBPACK FOOTER //
// src/modules/screens/settings/EmailTemplete/components/index.js